module.exports = __webpack_public_path__ + "static/img/lamp.dcda994.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diwali/lamp.png
// module id = +rOx
// module chunks = 0